import { Component, Input } from '@angular/core';
import { CommonService } from './shared/common.service';
import { ApiService } from './shared/api';
import { TokenStorageService } from './shared/token-storage';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  window = window;
  updateVar(e) {
    this[e.key] = e.value
  }

  constructor(public commonService: CommonService, apiService: ApiService, tokenStorage: TokenStorageService) {
    apiService.tokenExpired.subscribe(() => {
      console.log("Event fetched");
      tokenStorage.signOut();
      window.location.reload();
    });
  }
}
